import type { ReactNode, ElementType } from "react";
// @ts-expect-error pure js
import { classnames } from "../../utils";

import Card from "./Card";
import Text, { type Color } from "./Text";
import Button from "./Button";
import styles from "./DataCard.module.css";

interface DataCardProps {
  title: string;
  value?: string | number;
  valueSuffix?: string;
  subtitle?: string;
  icon: ElementType;
  status?: Color;
  statusLabels?: Partial<Record<Color, string>>;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  children?: ReactNode;
}

export default function DataCard({
  title,
  value,
  valueSuffix,
  subtitle,
  icon: Icon,
  status,
  statusLabels,
  actionLabel,
  onAction,
  className,
  children,
}: DataCardProps) {
  const defaultStatusLabels: Partial<Record<Color, string>> = {
    success: "OK",
    warning: "Attention",
    danger: "Erreur",
  };

  const labels = { ...defaultStatusLabels, ...statusLabels };

  return (
    <Card className={className} padding="md">
      <div className={styles.header}>
        <Text weight="bold">{title}</Text>
        <div className={styles.icon}>
          <Icon size={20} />
        </div>
      </div>
      <div>
        {value && (
          <div className={styles.valueRow}>
            <Text as="span" variant="mega" weight="bold">
              {value}
              {valueSuffix && (
                <Text as="span" variant="deci">
                  {" "}
                  {valueSuffix}
                </Text>
              )}
            </Text>
            {status && (
              <Text
                as="span"
                className={classnames(styles.status)}
                color={status}
                background
                weight="medium"
                variant="deci"
              >
                {labels[status]}
              </Text>
            )}
          </div>
        )}
        {subtitle && <Text variant="deci">{subtitle}</Text>}
        {actionLabel && onAction && (
          <Button
            variant="secondary"
            className={styles.action}
            onClick={onAction}
          >
            {actionLabel}
          </Button>
        )}
        {children}
      </div>
    </Card>
  );
}

interface DataCardGridProps {
  children: ReactNode;
  className?: string;
}

DataCard.Grid = function DataCardGrid({
  children,
  className,
}: DataCardGridProps) {
  return <div className={classnames(styles.grid, className)}>{children}</div>;
};
